export const delayFunctionCall = (fn: (...args: any[]) => void, delay?: number) => {
  setTimeout(() => {
    fn();
  }, delay ?? 0);
};

export const asyncDelay = (m: number) => new Promise((resolve) => setTimeout(resolve, m));
